import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.add_source_error."

export function AddSourceErrorToast(props: Props) {
  const {
    id,
    code,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1000: // dexcom bridge over nightscout
          return polyglot.t(`${polyglotPrefix}nightscout_dexcom_bridge_body`)
        case 1018: // tandem unsupported country
          return polyglot.t(`${polyglotPrefix}tandem_unsupported_country_body`)
        case 1019: // tandem auth expired
          return polyglot.t(`${polyglotPrefix}tandem_auth_expired_body`)
        case 1020: // tandem oauth error
          return polyglot.t(`${polyglotPrefix}tandem_oauth_error_body`)
        case 1025: // tandem oauth error
          return polyglot.t(`${polyglotPrefix}tandem_duplicate_error_body`)
        default:
          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
